/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { lateextras_LateExtrasRegenerateResponse } from '../models/lateextras_LateExtrasRegenerateResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class LateExtrasService {
    /**
     * Re-issue the invoices of a late extras item
     * Re-reads which of the item's extras are still late, then re-issues every issued invoice they would have been on, one after the other, through the invoice correction (the invoice is cancelled, a corrected DRAFT with a fresh number carries the extras). When every invoice succeeded the item moves to regenerated; on a failure it stays pending with the per-invoice results and a second call re-runs only the failed invoices. Admin only (#2028).
     * @param id Workflow item ID
     * @returns lateextras_LateExtrasRegenerateResponse OK
     * @throws ApiError
     */
    public static postApiV1LateExtrasRegenerate(
        id: string,
    ): CancelablePromise<lateextras_LateExtrasRegenerateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/late-extras/{id}/regenerate',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `LATE_EXTRAS_NOT_PENDING or LATE_EXTRAS_REGENERATING`,
                500: `Internal Server Error`,
            },
        });
    }
}
